import React, { PureComponent } from 'react';
import 'eventsource-polyfill';
import { getUser } from '../../services/auth';
import '../../css/tvCSS/style.css';
import api from '../../services/api';
import sound from './call_sound.mp3';
import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client';

webstomp.debug = null;

export default class Painel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      senhaAtual: { local: '', atendente: '', cliente: '' },
      senhasAnteriores: [],
      dataAtual: '',
      anoAtual: '',
      horaAtual: '',
      webSocketConnected: false,
      client: null,
      somAtivo: false,
    };

    this._connecting = false;
    this.audioRef = null;
  }

  componentDidMount() {
    this.connectAndReconnect();
    this.getSenhas();
    this.atualizarDataHora();
    this.intervalo = setInterval(this.atualizarDataHora, 1000);
  }

  componentWillUnmount() {
    if (this.intervalo) clearInterval(this.intervalo);

    // encerra ws (melhor esforço)
    try {
      const client = this.state.client;
      if (client && client.connected) client.disconnect(() => {});
    } catch (e) {}
  }

  atualizarDataHora = () => {
    const dataAtual = new Date();
    const dataFormatada = dataAtual.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });
    const anoFormatado = dataAtual.getFullYear();
    const horaFormatada = dataAtual.toLocaleTimeString();

    this.setState({
      dataAtual: dataFormatada,
      anoAtual: anoFormatado,
      horaAtual: horaFormatada,
    });
  };

  // ===== DEDUPE (não confia em id) =====
  keyOfSenha = (s) => {
    if (!s) return '';
    const prefix = s.prefixFila || '';
    const num = s.number != null ? String(s.number) : '';
    const fila = s.filaId != null ? String(s.filaId) : '';
    // chave estável (mesma senha = mesma chave)
    return [prefix, num, fila].join('|');
  };

  isSenhaVazia = (s) => {
    return (
      !s ||
      (!s.cliente &&
        !s.local &&
        !s.atendente &&
        !s.prefixFila &&
        s.number == null)
    );
  };

  // se o back mandar duplicado, mantém 1 só.
  // se tiver datahora, dá preferência ao mais recente.
  dedupByKeyPreferNewest = (list) => {
    const map = {}; // key -> senha
    for (let i = 0; i < list.length; i++) {
      const s = list[i];
      if (!s || this.isSenhaVazia(s)) continue;

      const k = this.keyOfSenha(s);
      if (!k || k === '||') continue;

      const prev = map[k];
      if (!prev) {
        map[k] = s;
        continue;
      }

      // Preferir o mais recente pela datahora, se existir
      const a = prev.datahora ? Date.parse(prev.datahora) : NaN;
      const b = s.datahora ? Date.parse(s.datahora) : NaN;

      if (!Number.isNaN(a) && !Number.isNaN(b)) {
        if (b >= a) map[k] = s;
      } else {
        // sem data confiável: mantém o primeiro (ou troque pra "sempre o último" se quiser)
        // map[k] = s;
      }
    }

    // respeitar a ordem original (mais novo primeiro), mas com valores "winner"
    const seen = new Set();
    const out = [];
    for (let i = 0; i < list.length; i++) {
      const s = list[i];
      const k = this.keyOfSenha(s);
      if (!k || k === '||') continue;
      if (seen.has(k)) continue;
      seen.add(k);

      const winner = map[k];
      if (winner && !this.isSenhaVazia(winner)) out.push(winner);
    }

    return out;
  };

  applySenha = (senhaNova) => {
    this.setState((prev) => {
      const merged = [
        senhaNova,
        prev.senhaAtual,
        ...(prev.senhasAnteriores || []),
      ].filter(Boolean);

      const unique = this.dedupByKeyPreferNewest(merged);

      return {
        senhaAtual: unique[0] || senhaNova || prev.senhaAtual,
        senhasAnteriores: unique.slice(1, 4),
      };
    });
  };

  // ===== WS =====
  connectAndReconnect = () => {
    const user = getUser();
    const estabelecimento =
      user && user.estabelecimento ? user.estabelecimento : null;
    const cnpj = estabelecimento ? estabelecimento.cpfCnpj : null;

    if (!cnpj) {
      console.log('Sem estabelecimento/cnpj no usuário. Não vou conectar WS.');
      return;
    }

    if (this._connecting) return;
    this._connecting = true;

    const doConnect = () => {
      const sock = new SockJS(window.IP_SERVER_WS);

      if (window.location.hostname === 'localhost') {
        window._sock = sock;
      }

      const client = webstomp.over(sock);

      if (window.location.hostname === 'localhost') {
        window._client = client;
      }

      this.setState({ client });

      client.connect(
        {},
        () => {
          this._connecting = false;
          this.setState({ webSocketConnected: true });

          client.subscribe('/topic/senhas/' + cnpj, this.handleDataUpdate);
        },
        () => {
          this._connecting = false;
          this.setState({ webSocketConnected: false, client: null });
          setTimeout(doConnect, 5000);
        },
      );

      sock.onclose = () => {
        this._connecting = false;
        this.setState({ webSocketConnected: false, client: null });
        setTimeout(doConnect, 5000);
      };
    };

    doConnect();
  };

  handleDataUpdate = (messageOutput) => {
    try {
      const senha = JSON.parse(messageOutput.body);
      console.log(
        'WS senha:',
        senha.id,
        senha.prefixFila,
        senha.number,
        senha.cliente,
      );
      this.playSound();
      this.applySenha(senha);
    } catch (e) {
      console.log('Falha ao processar WS message', e);
    }
  };

  // ===== Som =====
  ativarSom = () => {
    if (!this.audioRef) return;

    try {
      this.audioRef.muted = false;
      this.audioRef.volume = 1.0;

      const p = this.audioRef.play();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {}

    this.setState({ somAtivo: true });
  };

  playSound = () => {
    if (!this.state.somAtivo) return;
    if (!this.audioRef) return;

    try {
      this.audioRef.pause();
      this.audioRef.currentTime = 0;

      const p = this.audioRef.play();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {
      console.log('Erro ao tocar áudio', e);
    }
  };

  // ===== REST =====
  getSenhas = () => {
    api.get('/senha/all').then(
      (r) => {
        const list = Array.isArray(r.data) ? r.data : [];
        if (!list.length) return;

        const unique = this.dedupByKeyPreferNewest(list);

        this.setState({
          senhaAtual: unique[0] || { local: '', atendente: '', cliente: '' },
          senhasAnteriores: unique.slice(1, 4),
        });
      },
      (erro) => {
        console.log('erro do senha all', erro);
      },
    );
  };

  render() {
    const user = getUser();
    const estabelecimento =
      user && user.estabelecimento ? user.estabelecimento : { nome: '' };

    return (
      <>
        <audio id="audio" ref={(ref) => (this.audioRef = ref)}>
          <source src={sound} type="audio/mpeg" />
          <source src="./call_sound.ogg" type="audio/ogg; codecs=vorbis" />
        </audio>

        {!this.state.somAtivo && (
          <button
            onClick={this.ativarSom}
            style={{
              position: 'absolute',
              top: 7,
              left: 7,
              padding: '5px 7px 5px 7px',
              fontSize: 12,
              zIndex: 9999,
              borderRadius: 10,
              background: 'rgb(234 240 244)',
              color: '#000',
              cursor: 'pointer',
              border: '1px solid',
            }}
          >
            Ativar Som
          </button>
        )}

        <div className="top d-flex justify-content-between align-items-center">
          <div>
            <h2 id="dataAtual">{this.state.dataAtual}</h2>
            <h2 className="year" id="anoAtual">
              {this.state.anoAtual}
            </h2>
          </div>

          <h1 id="nomeEstabelecimento">{estabelecimento.nome}</h1>

          <h2 id="horaAtual">{this.state.horaAtual}</h2>
        </div>

        <div className="ON callAnimate" id="painelAnimado">
          {this.state.senhaAtual &&
            !this.isSenhaVazia(this.state.senhaAtual) && (
              <div
                className="chamada d-flex flex-column align-items-center justify-content-center"
                id="current"
              >
                <div className="txtPaciente" id="currentPaciente">
                  {this.state.senhaAtual.cliente}
                </div>

                {this.state.senhaAtual.prefixFila &&
                  this.state.senhaAtual.number != null && (
                    <div className="txtSenha" id="currentSenha">
                      Senha:{' '}
                      {this.state.senhaAtual.prefixFila +
                        '-' +
                        this.state.senhaAtual.number}
                    </div>
                  )}

                <div className="txtSala" id="currentLocal">
                  {this.state.senhaAtual.local}
                </div>

                <div className="txtProfissional" id="currentProfissional">
                  <i>{this.state.senhaAtual.atendente}</i>
                </div>
              </div>
            )}

          <div
            className="atendimentosAnteriores d-flex justify-content-center row"
            id="atendimentosAteriores"
          >
            {this.state.senhasAnteriores.map((senha) => {
              const k = this.keyOfSenha(senha) || String(Math.random());
              return (
                <div key={k} className="itemAnterior col">
                  <div className="txtPaciente">{senha.cliente}</div>
                  <div className="txtSala">{senha.local}</div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}
